import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeComponent from './pages/HomeComponent';
import DigitalConfirmComponent from './pages/DigitalConfirmComponent';
import DigitalConfirmRoyalSaluteComponent from './pages/DigitalConfirmRoyalSaluteComponent';
import DigitalConfirmRoyalSalute2Component from './pages/DigitalConfirmRoyalSalute2Component';
import DigitalConfirmArtVentureNFT from './pages/DigitalConfirmArtVentureNFT';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeComponent />} />
        <Route path="/:slug" element={<DigitalConfirmComponent />} />
        <Route path="/royal-salute/avt" element={<DigitalConfirmRoyalSaluteComponent />} />
        <Route path="/royal-salute/avt01" element={<DigitalConfirmRoyalSalute2Component />} />
        <Route path="/art/artventurenft" element={<DigitalConfirmArtVentureNFT/>} />
      </Routes>
    </Router>
  );
};

export default App;
